import React from 'react';
import { Button, ModalBox } from '@fourthwall/components';
import { FeatureFlagDecorator } from '@components/utils/FeatureFlagDecorator';
import { useAdminModeContext } from '@modules/App/providers/AdminModeProvider';
const Wrapper = ({ children }) => {
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', padding: '24px' } }, children));
};
export const UnavailableProductModalAlert = ({ text, close, handleEditClick, }) => {
    const adminMode = useAdminModeContext();
    return (React.createElement(ModalBox, { title: "Product is currently unavailable", buttons: [
            React.createElement(FeatureFlagDecorator, { enabled: Boolean(adminMode?.isActive), highlight: true, description: "Admin", spacing: "large", wrapper: Wrapper },
                React.createElement(Button, { label: "Edit Design", appearance: "secondary", onClick: () => handleEditClick() })),
            React.createElement(Button, { label: "Close", appearance: "primary", onClick: close }),
        ] }, text));
};
